import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchMedia } from 'slices/influencer/thunk';
import { AppDispatch, RootState } from 'store';
import { useParams } from 'react-router-dom';
import { fetchApplicationPosts } from 'slices/campaigns/applications/thunk';
import { SocialPost } from 'types/campaign/collaborations';
import MediaGrid from './SocialMediaGrid';


interface InfluencerRelevantMediaProps {
    influencerId: string,
    onMediaClick: (post: SocialPost) => void
}

const InfluencerRelevantMedia:React.FC<InfluencerRelevantMediaProps> = ({influencerId, onMediaClick}) => {
    const dispatch: AppDispatch = useDispatch();

    const {campaignId} = useParams();

    const applicationPosts = useSelector((state: RootState) => state.campaignApplications.posts[campaignId!]?.[influencerId])
    const loading = useSelector((state: RootState) => state.campaignApplications.postsLoading);
    const media = applicationPosts?.items ?? [];

    useEffect(() => {
        if (influencerId && campaignId)
            dispatch(fetchApplicationPosts({ influencerId, campaignId }));
    }, [influencerId, campaignId])

    const nextPage = () => {
       //No pagination
    }

    return (
        <MediaGrid onGridItemClick={onMediaClick} media={media.map((aPost) => ({...aPost.social_post, bookmarked: aPost.bookmarked}))} onNextPage={nextPage} has_more={false} contentLoading={loading} />
    )
}

export default InfluencerRelevantMedia